import React, { Component } from "react";
import LocalizedStrings from "react-localization";
import en from "../../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });
class YayScore extends Component {
  state = { yayscorePost: 5, yayscoreLike: 1, yayscoreReferral: 25 };
  render() {
    const score =
      this.props.user.total_likes * this.state.yayscoreLike +
      this.props.user.total_recommendations * this.state.yayscorePost +
      this.props.user.invites * this.state.yayscoreReferral;
    return (
      <div className="max_width_500 pb-2 pt-2">
        <label className="name pb-2">{strings.yayscore}</label>
        <div className="row">
          <div className="col-sm-4" />
          <div className="col-sm-4">
            <label className="number">{score}</label>
            {/* <label className="subtitles pb-2">{strings.referrals}</label> */}
          </div>
          <div className="col-sm-4" />
        </div>
      </div>
    );
  }
}

export default YayScore;



// WEBPACK FOOTER //
// ./src/components/profile/modal/Yayscore.jsx